import React from "react";
import { Switch } from "react-router-dom";

import { PrivateRoute } from "./PrivateRoute";
import {
  EditAlert,
  ListAlerts,
  NewAlert,
  EditCompany,
  ListCompanies,
  NewCompany,
  ListCarriers,
  EditCarrier,
  NewCarrier,
  ListClients,
  EditClient,
  NewClient,
  ListClientTypes,
  EditClientType,
  NewClientType,
  ListBusiness,
  NewBusiness,
  EditBusiness,
  ListBusinessUnits,
  NewBusinessUnit,
  EditBusinessUnit,
  ListUsers,
  NewUser,
  EditUser,
  ListProducts,
  NewProduct,
  EditProduct,
  EditProductType,
  ListProductTypes,
  NewProductType,
  EditVehicle,
  ListVehicles,
  NewVehicle,
  EditVehicleType,
  ListVehicleTypes,
  NewVehicleType,
  NewPalletType,
  ListPalletTypes,
  EditPalletType,
  ListAlertEmailLogs,
  ShowAlertEmailLogs,
} from "pages/Settings";

import { Main } from "pages/Main";
import {SettingMain} from "pages/Settings";

interface Props {}

export const SettingsRoutes: React.FC<Props> = () => {
  return (
    <Switch>
      <PrivateRoute path="/base" exact component={Main} />
      <PrivateRoute
        exact
        path="/settings"
        component={SettingMain}
        hasAnyPermission={["Administrador", "Customer Service"]}
      />
      <PrivateRoute
        exact
        path="/settings/alerts"
        component={ListAlerts}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/alert/new"
        component={NewAlert}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/alert/:id"
        component={EditAlert}
        hasEveryPermission={["Administrador"]}
      />
            <PrivateRoute
        exact
        path="/settings/alert-email-logs"
        component={ListAlertEmailLogs}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/alert-email-logs/:id"
        component={ShowAlertEmailLogs}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/companies"
        component={ListCompanies}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/company/new"
        component={NewCompany}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/company/:id"
        component={EditCompany}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/carriers"
        component={ListCarriers}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/carrier/new"
        component={NewCarrier}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/carrier/:id"
        component={EditCarrier}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/clients"
        component={ListClients}
        hasAnyPermission={["Administrador", "Customer Service"]}
      />
      <PrivateRoute
        exact
        path="/settings/client/new"
        component={NewClient}
        hasAnyPermission={["Administrador", "Customer Service"]}
      />
      <PrivateRoute
        exact
        path="/settings/client/:id"
        component={EditClient}
        hasAnyPermission={["Administrador", "Customer Service"]}
      />
      <PrivateRoute
        exact
        path="/settings/client-types"
        component={ListClientTypes}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/client-type/new"
        component={NewClientType}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/client-type/:id"
        component={EditClientType}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/business"
        component={ListBusiness}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/business/new"
        component={NewBusiness}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/business/:id"
        component={EditBusiness}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/business-units"
        component={ListBusinessUnits}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/business-units/new"
        component={NewBusinessUnit}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/business-units/:id"
        component={EditBusinessUnit}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/users"
        component={ListUsers}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/user/new"
        component={NewUser}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/user/:id"
        component={EditUser}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/products"
        component={ListProducts}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/products/new"
        component={NewProduct}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/products/:id"
        component={EditProduct}
        hasEveryPermission={["Administrador"]}
      />

      <PrivateRoute
        exact
        path="/settings/product-types"
        component={ListProductTypes}
        hasEveryPermission={["Administrador"]}
      />

      <PrivateRoute
        exact
        path="/settings/product-types/new"
        component={NewProductType}
        hasEveryPermission={["Administrador"]}
      />

      <PrivateRoute
        exact
        path="/settings/product-types/:id"
        component={EditProductType}
        hasEveryPermission={["Administrador"]}
      />

      <PrivateRoute
        exact
        path="/settings/vehicles"
        component={ListVehicles}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/vehicle/new"
        component={NewVehicle}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/vehicle/:id"
        component={EditVehicle}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/vehicle-types"
        component={ListVehicleTypes}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/vehicle-type/new"
        component={NewVehicleType}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/vehicle-type/:id"
        component={EditVehicleType}
        hasEveryPermission={["Administrador"]}
      />
      <PrivateRoute
        exact
        path="/settings/pallet-types"
        component={ListPalletTypes}
        hasEveryPermission={["Administrador"]}
      />

      <PrivateRoute
        exact
        path="/settings/pallet-types/new"
        component={NewPalletType}
        hasEveryPermission={["Administrador"]}
      />

      <PrivateRoute
        exact
        path="/settings/pallet-types/:id"
        component={EditPalletType}
        hasEveryPermission={["Administrador"]}
      />
    </Switch>
  );
};
